import React, { useEffect } from 'react';
import { initMetaPixel } from './lib/metaPixel';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { WhatItIs } from './components/WhatItIs';
import { WhatYouLearn } from './components/WhatYouLearn';
import { IncludesGrid } from './components/IncludesGrid';
import { TwentyOneDayPlan } from './components/TwentyOneDayPlan';
import { RecipesPreview } from './components/RecipesPreview';
import { ForYouOrNot } from './components/ForYouOrNot';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { PriceCTA } from './components/PriceCTA';
import { FAQ } from './components/FAQ';
import { Disclaimer } from './components/Disclaimer';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { SocialProofToast } from './components/SocialProofToast';
export function App() {
  useEffect(() => {
    initMetaPixel('26379291501680447');
  }, []);
  return <div className="min-h-screen bg-cream font-sans text-ink selection:bg-clay/20 selection:text-clay-dark pb-24 md:pb-24" data-id="element-0">
      <TopBar data-id="element-1" />
      <main data-id="element-2">
        {/* 1. Hook */}
        <Hero data-id="element-3" />
        {/* 2. Dolor / identificación */}
        <PainPoints data-id="element-4" />
        {/* 3. Claridad: qué es y qué no es */}
        <WhatItIs data-id="element-5" />
        {/* 4. Transformación: qué vas a aprender */}
        <WhatYouLearn data-id="element-6" />
        {/* 5. Valor apilado: todo lo que incluye */}
        <IncludesGrid data-id="element-7" />
        {/* 6. Método claro: plan de 21 días */}
        <TwentyOneDayPlan data-id="element-8" />
        {/* 7. Deseo visual: recetas */}
        <RecipesPreview data-id="element-9" />
        {/* 8. Calificación */}
        <ForYouOrNot data-id="element-10" />
        {/* 9. Prueba social */}
        <Testimonials data-id="element-11" />
        {/* 10. Seguridad: garantía */}
        <Guarantee data-id="element-12" />
        {/* 11. CTA con urgencia */}
        <PriceCTA id="pricing-section" data-id="element-13" />
        {/* 12. FAQ */}
        <FAQ data-id="element-14" />
        {/* 13. Legal */}
        <Disclaimer data-id="element-15" />
        {/* 14. Cierre emocional */}
        <FinalCTA data-id="element-16" />
      </main>
      <Footer data-id="element-17" />
      <StickyMobileCTA data-id="element-18" />
      <SocialProofToast data-id="element-19" />
    </div>;
}